// Client navigation can fetch a different nonce, but the browser still uses the original document policy.
// Read the original script element's .nonce property; browsers hide the value from getAttribute('nonce').
export function getDocumentCspNonce(): string {
  if (typeof document === 'undefined') return ''
  return document.querySelector<HTMLScriptElement>('#env-config')?.nonce || ''
}
